module.exports = __webpack_public_path__ + "img/calendario-verde.c190092e.svg";